/*es6-iterator/is-iterable*/
function _(require, module, exports) {
    var isArguments = require(274    /* es5-ext/function/is-arguments */), isValue = require(295    /* es5-ext/object/is-value */), isString = require(310    /* es5-ext/string/is-string */);
    var iteratorSymbol = require(325    /* es6-symbol */).iterator, isArray = Array.isArray;
    module.exports = function (value) {
        if (!isValue(value))
            return false;
        if (isArray(value))
            return true;
        if (isString(value))
            return true;
        if (isArguments(value))
            return true;
        return typeof value[iteratorSymbol] === 'function';
    };
}